<template>
    <div class="vh-100">
        <DataDashboard
            class="data_dashboard"
            ref="toDashboardFunc"
            v-on:ToNotification="ToChildNotification"
            v-on:ToChildBank="ToChildBank"
            v-on:ToChildMerchantOnline="ToChildMerchantOnline"
            v-on:ToChildEDC="ToChildEDC"
            v-on:ToChildKeuangan="ToChildKeuangan"
            v-on:ToChildSnapOnline="ToChildSnapOnline"
            v-on:ToChildSnapOffline="ToChildSnapOffline"
            v-on:ToChildSnapRunning="ToChildSnapRunning"
            v-on:ToChildJenisSatuan="ToChildJenisSatuan"
            v-on:ToChildKeuanganInOut="ToChildKeuanganInOut"
        />
        <Notification ref="toNotificationFunc" class="data_notification" v-on:ToChildDashboard="ToChildDashboard" />
        <Bank ref="toBankFunc" class="data_bank" v-on:ToChildDashboard="ToChildDashboard" />
        <MerchantOnline
            ref="toMerchantOnlineFunc"
            class="data_merchant_online"
            v-on:ToChildDashboard="ToChildDashboard"
        />
        <ListKasEDC ref="toListKasEDCFunc" class="data_edc" v-on:ToChildDashboard="ToChildDashboard" />
        <Keuangan ref="toKeuanganFunc" class="data_keuangan" v-on:ToChildDashboard="ToChildDashboard" />
        <Mesin class="data_mesin" v-on:ToChildDashboard="ToChildDashboard" ref="StatusMesinSnap" />
        <JenisSatuan class="satuan_component" v-on:ToChildDashboard="ToChildDashboard" ref="StatusJenisSatuan" />
        <DetailPendapatan
            class="detail_keuangan_in_out"
            v-on:ToChildDashboard="ToChildDashboard"
            ref="DetailKeuangan"
        />
    </div>
</template>
<script>
import DataDashboard from "../Dashboard/DataDashboard";
import Notification from "../Dashboard/Notification";
import Bank from "../Dashboard/ListKasBank";
import MerchantOnline from "../Dashboard/ListKasMerchantOnline";
import ListKasEDC from "../Dashboard/ListKasEDC";
import Keuangan from "../Dashboard/ListKasLaci";
import Mesin from "../Dashboard/ListMesinSnap";
import JenisSatuan from "../Dashboard/ListJenisSatuan";
import DetailPendapatan from "../Dashboard/ListDetailPendapatanPengeluaran";
import SOModalAnnouncement from "@/so-components/global/modal/SOModalAnnouncement";

import Firebase from "vue-firebase";

export default {
    name: "Dashboard",
    components: {
        firebase: Firebase,
        Notification,
        Bank,
        MerchantOnline,
        ListKasEDC,
        DataDashboard,
        DetailPendapatan,
        Keuangan,
        JenisSatuan,
        Mesin,
        SOModalAnnouncement,
    },
    data() {
        return {
            owner: [],
            idoutlet: "",
            requestHeaders: {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            },
        };
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            if (vm.isWebview()) {
                const initRoute = vm.$store.state.metaModule.initRoute;
                if (initRoute == null) return
                if (initRoute != '/dashboard') {
                    vm.flutterNavigate('dashboard');   
                    return
                }
            }
        });
    },
    mounted() {
        $(".data_dashboard").hide();
        $(".data_notification").hide();
        $(".data_bank").hide();
        $(".data_merchant_online").hide();
        $(".data_edc").hide();

        $(".data_keuangan").hide();
        $(".data_mesin").hide();
        $(".satuan_component").hide();
        $(".detail_keuangan_in_out").hide();

        this.ToChildDashboard();

        if (this.getUserAgent() !== "ios") {
            const vapidkey = process.env.VUE_APP_FCM_VAPID_KEY;
            const messaging = firebaseToken.messaging();
            messaging
                .getToken({ vapidKey: vapidkey })
                .then((currentToken) => {
                    if (currentToken) {
                        localStorage.setItem("curent-token-firebase", currentToken);
                        this.SubscribeTokenToTopic(currentToken);
                    } else {
                        console.log("No Instance ID token available. Request permission to generated.");
                    }
                })
                .catch((err) => {
                    console.log("An error occurred while retrieving token. ", err);
                });

            // messaging.onMessage(function (payload) {
            //     console.log(
            //         "[firebase-messaging-sw.js] Received foregrond message ", payload
            //     );
            //     Notification.requestPermission(function (result) {
            // 	        if (result === 'granted') {
            // 		        navigator.serviceWorker.ready.then(function (registration) {
            // 			        registration.showNotification(payload.notification.title, {
            // 				        body: payload.notification.body,
            // 				        actions: [{
            // 					        title: 'Lihat Sekarang',
            // 					        action: 'https://smartlink-frontend-v1-fljnd6wana-de.a.run.app/'
            // 				        }],
            // 				        icon: payload.notification.icon,
            // 				        badge: payload.notification.icon,
            // 				        vibrate: [500, 110, 500, 110, 450, 110, 200, 110, 170, 40, 450, 110, 200, 110, 170, 40, 500],
            // 				        tag: 'Bos-revamp-dev'
            // 			        });
            // 		        });
            //
            // 	        }
            //         }
            //     );
            //
            //     const audio = new Audio("../../assets/audio/notify.mp3");
            //     audio.play();
            // });
        }
        this.smartTrackingView('dashboard')

    },
    methods: {
        ToChildDashboard() {
            $(".data_dashboard").show();
            $(".data_notification").hide();
            $(".data_bank").hide();
            $(".data_merchant_online").hide();
            $(".data_edc").hide();
            $(".data_keuangan").hide();
            $(".data_mesin").hide();
            $(".satuan_component").hide();
            $(".detail_keuangan_in_out").hide();
            this.$refs.toDashboardFunc.toTop();
            // this.$refs.toDashboardFunc.splide();
            this.$refs.toDashboardFunc.getUnseenNotifications();
        },
        BackDashboard() {
            alert("cek by developer");
        },
        ToChildNotification() {
            this.$refs.toNotificationFunc.toTop();
            $(".data_dashboard").hide();
            $(".data_notification").show();
            $(".data_bank").hide();
            $(".data_merchant_online").hide();
            $(".data_edc").hide();
            $(".data_keuangan").hide();
            $(".data_mesin").hide();
            $(".satuan_component").hide();
            $(".detail_keuangan_in_out").hide();
        },
        ToChildKeuangan() {
            this.$refs.toKeuanganFunc.toTop();
            $(".data_dashboard").hide();
            $(".data_notification").hide();
            $(".data_bank").hide();
            $(".data_merchant_online").hide();
            $(".data_edc").hide();
            $(".data_keuangan").show();
            $(".data_mesin").hide();
            $(".satuan_component").hide();
            $(".detail_keuangan_in_out").hide();
        },
        ToChildBank() {
            this.$refs.toBankFunc.toTop();
            $(".data_dashboard").hide();
            $(".data_notification").hide();
            $(".data_bank").show();
            $(".data_merchant_online").hide();
            $(".data_edc").hide();
            $(".data_keuangan").hide();
            $(".data_mesin").hide();
            $(".satuan_component").hide();
            $(".detail_keuangan_in_out").hide();
        },
        ToChildMerchantOnline() {
            this.$refs.toMerchantOnlineFunc.toTop();
            $(".data_dashboard").hide();
            $(".data_notification").hide();
            $(".data_bank").hide();
            $(".data_merchant_online").show();
            $(".data_edc").hide();
            $(".data_keuangan").hide();
            $(".data_mesin").hide();
            $(".satuan_component").hide();
            $(".detail_keuangan_in_out").hide();
        },
        ToChildEDC() {
            this.$refs.toListKasEDCFunc.toTop();
            $(".data_dashboard").hide();
            $(".data_notification").hide();
            $(".data_bank").hide();
            $(".data_merchant_online").hide();
            $(".data_edc").show();
            $(".data_keuangan").hide();
            $(".data_mesin").hide();
            $(".satuan_component").hide();
            $(".detail_keuangan_in_out").hide();
        },
        ToChildSnapOffline() {
            $(".data_dashboard").hide();
            $(".data_notification").hide();
            $(".data_bank").hide();
            $(".data_merchant_online").hide();
            $(".data_edc").hide();
            $(".data_keuangan").hide();
            $(".data_mesin").show();
            $(".satuan_component").hide();
            $(".detail_keuangan_in_out").hide();
            this.$refs.StatusMesinSnap.mesinOfflineFunction();
            this.$refs.StatusMesinSnap.toTop();
        },
        ToChildSnapOnline() {
            $(".data_dashboard").hide();
            $(".data_notification").hide();
            $(".data_bank").hide();
            $(".data_merchant_online").hide();
            $(".data_edc").hide();
            $(".data_keuangan").hide();
            $(".data_mesin").show();
            $(".satuan_component").hide();
            $(".detail_keuangan_in_out").hide();
            this.$refs.StatusMesinSnap.mesinOnlineFunction();
            this.$refs.StatusMesinSnap.toTop();
        },
        ToChildSnapRunning() {
            $(".data_dashboard").hide();
            $(".data_notification").hide();
            $(".data_bank").hide();
            $(".data_merchant_online").hide();
            $(".data_edc").hide();
            $(".data_keuangan").hide();
            $(".data_mesin").show();
            $(".satuan_component").hide();
            $(".detail_keuangan_in_out").hide();
            this.$refs.StatusMesinSnap.mesinRunningFunction();
            this.$refs.StatusMesinSnap.toTop();
        },
        ToChildJenisSatuan(params) {
            this.$refs.StatusJenisSatuan.FilterJenisSatuan(params.parameter, params.periode);
            this.$refs.StatusJenisSatuan.toTop();
            $(".data_dashboard").hide();
            $(".data_notification").hide();
            $(".data_bank").hide();
            $(".data_merchant_online").hide();
            $(".data_edc").hide();
            $(".data_keuangan").hide();
            $(".data_mesin").hide();
            $(".satuan_component").show();
            $(".detail_keuangan_in_out").hide();
        },
        ToChildKeuanganInOut(params) {
            this.$refs.DetailKeuangan.FilterPendapatanPengeluaran(params.parameter, params.periode);
            this.$refs.DetailKeuangan.toTop();
            $(".data_dashboard").hide();
            $(".data_notification").hide();
            $(".data_bank").hide();
            $(".data_merchant_online").hide();
            $(".data_edc").hide();
            $(".data_keuangan").hide();
            $(".data_mesin").hide();
            $(".satuan_component").hide();
            $(".detail_keuangan_in_out").show();
        },

        async SubscribeTokenToTopic(token) {
            var tokenAccount = localStorage.getItem("token");
            var base64Url = tokenAccount.split(".")[1];
            var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
            var jsonPayload = decodeURIComponent(
                atob(base64)
                    .split("")
                    .map(function(c) {
                        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
                    })
                    .join("")
            );

            var dataToken = JSON.parse(jsonPayload);

            if (dataToken.Readonly == false) {
                const fcm_server_key = process.env.VUE_APP_FCM_SERVER_KEY;
                var topic = "all";
                try {
                    const response = await this.$axios.post(
                        "https://iid.googleapis.com/iid/v1/" + token + "/rel/topics/" + topic,
                        null,
                        {
                            headers: {
                                Authorization: "key=" + fcm_server_key,
                            },
                        }
                    );
                    if (response.status > 400 || response.status < 200) {
                        throw "Error subscribing to topic: " + response.status + " - " + response.text();
                    } else {
                        console.log("Success set topic");
                    }
                } catch (e) {
                    console.error(e);
                }
            }
        },
    },
    async ParseJwt(token) {
        var base64Url = token.split(".")[1];
        var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        var jsonPayload = decodeURIComponent(
            atob(base64)
                .split("")
                .map(function(c) {
                    return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
                })
                .join("")
        );

        return JSON.parse(jsonPayload);
    },
};
</script>
<style>
body {
    -webkit-user-select: none; /* Safari */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* IE10+/Edge */
    user-select: none; /* Standard */
}
</style>
